import { c as _c } from "react/compiler-runtime";
import NumberInput from "@components/hookform/NumberInput";
import { QualificationFormData } from "@modules/booking/context/types";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
type IncomeFormValues = Pick<QualificationFormData, "income">;
interface IncomeFormProps {
  onSubmit: (data: IncomeFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const IncomeForm = t0 => {
  const $ = _c(27);
  const {
    onSubmit,
    canGoBack,
    onGoBack,
    isLoading,
    isError
  } = t0;
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    control,
    handleSubmit,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  let t3;
  if ($[1] !== handleSubmit || $[2] !== onSubmit) {
    t3 = handleSubmit(onSubmit);
    $[1] = handleSubmit;
    $[2] = onSubmit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("incomeForm.incomeLabel");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("incomeForm.incomePlaceholder");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("incomeForm.incomeRequiredError");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      required: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = errors.income?.message;
  let t9;
  if ($[12] !== control || $[13] !== t4 || $[14] !== t5 || $[15] !== t7 || $[16] !== t8) {
    t9 = <FormRow><FormField><NumberInput name="income" label={t4} placeholder={t5} suffix={"\u20AC"} control={control} rules={t7} errorMessage={t8} /></FormField></FormRow>;
    $[12] = control;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <Form id="income-form" onSubmit={t3}>{t9}</Form>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== canGoBack || $[22] !== isError || $[23] !== isLoading || $[24] !== onGoBack || $[25] !== t10) {
    t11 = <FormSection formId="income-form" canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>{t10}</FormSection>;
    $[21] = canGoBack;
    $[22] = isError;
    $[23] = isLoading;
    $[24] = onGoBack;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default IncomeForm;